import { useAdminCombinedNodeInfoLazyQuery, useAdminCombinedTableInfoLazyQuery, useGetFalconSummaryLazyQuery, useGetSageSummaryLazyQuery, } from "../../generated/graphql-types";
export const useGetFalconSummaryQuery = () => {
    const [getFalconSummary, { data, error, loading },] = useGetFalconSummaryLazyQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        getFalconSummary,
        error,
        loading,
        data: data?.Admin_getFalconSummary,
    };
};
export const useGetSageSummaryQuery = () => {
    const [getSageSummary, { data, error, loading },] = useGetSageSummaryLazyQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        getSageSummary,
        error,
        loading,
        data: data?.Admin_getSageSummary,
    };
};
export const useGetAdminCombinedNodeInfo = () => {
    const [getAdminCombinedNodeInfo, { data, error, loading },] = useAdminCombinedNodeInfoLazyQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        getAdminCombinedNodeInfo,
        error,
        loading,
        data: data?.Admin_combinedNodeInfo,
    };
};
export const useGetAdminCombinedTableInfo = () => {
    const [getAdminCombinedTableInfo, { data, error, loading },] = useAdminCombinedTableInfoLazyQuery({
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.Admin_combinedTableInfo,
        getAdminCombinedTableInfo: (node) => {
            getAdminCombinedTableInfo({
                variables: {
                    node,
                },
            });
        },
    };
};
//# sourceMappingURL=table-status-service.js.map